export default __webpack_public_path__ + "static/media/linkedin.f10c9de5.svg";